import { z } from "zod";
import { QualityInputBundleV1Schema } from "./quality-input-bundle.js";
/** render-result.v1.0 — Surface Engine output (same bundle shape Quality consumes) */
export const RenderResultV1Schema = QualityInputBundleV1Schema.extend({
    schemaVersion: z.literal("render-result.v1.0"),
});
//# sourceMappingURL=render-result.js.map